import { render, staticRenderFns } from "./batchActivate.vue?vue&type=template&id=81450054&scoped=true&"
import script from "./batchActivate.vue?vue&type=script&lang=js&"
export * from "./batchActivate.vue?vue&type=script&lang=js&"
import style0 from "./batchActivate.vue?vue&type=style&index=0&id=81450054&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81450054",
  null
  
)

export default component.exports